import {FC} from 'react';
import PropTypes from 'prop-types';
import {FilterButton} from '~/GalleryPB/FilterButton';
import {ResultsCount} from '~/GalleryPB/ResultsCount';

interface ResultsHeaderProps {
  showFilterButton?: boolean;
  onFilterButtonClick?: () => void;
  numTemplates?: number;
}

export const ResultsHeader: FC<ResultsHeaderProps> = ({
  showFilterButton,
  onFilterButtonClick,
  numTemplates,
}) => (
  <div className="gallery__results-header">
    {showFilterButton && <FilterButton onClick={onFilterButtonClick} />}
    {numTemplates !== undefined && <ResultsCount numTemplates={numTemplates} />}
  </div>
);

ResultsHeader.propTypes = {
  onFilterButtonClick: PropTypes.func,
  numTemplates: PropTypes.number,
  showFilterButton: PropTypes.bool,
};
